import * as actionTypes from "../actionTypes";

const initialState = {
  toastMsgs: [],
  alertMsg: null,
};

const toastReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOAST_MSG:
      return {
        ...state,
        toastMsgs: [
          ...state.toastMsgs,
          { id: action.id, text: action.text, msgtype: action.msgtype },
        ],
      };
    case actionTypes.EMPTY_TOAST_MSG:
      return { ...state, toastMsgs: [] };
    case actionTypes.HIDE_TOAST_MSG:
      return {
        ...state,
        toastMsgs: state.toastMsgs.filter((notification) => {
          return notification.id !== action.id;
        }),
      };
    case actionTypes.ALERT_MSG:
      return {
        ...state,
        alertMsg: {
          title: action.title,
          text: action.text,
          msgtype: action.msgtype,
        },
      };
    case actionTypes.EMPTY_ALERT_MSG:
      return { ...state, alertMsg: null };
    default:
      return state;
  }
};
export default toastReducer;
